module.exports = __webpack_public_path__ + "img/公众号开发.7cc67806.gif";